import { render, staticRenderFns } from "./OfferWide.vue?vue&type=template&id=7799c1b4&scoped=true&"
import script from "./OfferWide.vue?vue&type=script&lang=js&"
export * from "./OfferWide.vue?vue&type=script&lang=js&"
import style0 from "./OfferWide.vue?vue&type=style&index=0&id=7799c1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7799c1b4",
  null
  
)

export default component.exports